import { MAILING_API } from 'shared/components/dashboard-mail-editor/api/email-api'
import {
  EmailId,
  MailingApiInterface,
} from 'shared/components/dashboard-mail-editor/types/email-interface'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import { useOnceTrue } from 'shared/hooks/use-once-true'
import useUser from 'shared/hooks/use-user'
import useSWR from 'swr'

export function useEmail(emailId: EmailId, shouldFetch = true) {
  const { user } = useUser()

  const { fetcher } = useFetch<RequestMethodsEnum.get, MailingApiInterface>({
    method: RequestMethodsEnum.get,
  })

  const allowed = useOnceTrue(!!user && !!shouldFetch)
  return useSWR(() => {
    if (allowed) {
      return `${MAILING_API}/${emailId}`
    }
  }, fetcher)
}
